export default __webpack_public_path__ + "static/media/ethereum-eth-logo.b3ec96d9.svg";